import React from 'react';

const ComingSoon = () => (
  <div className="flex-1 flex items-center justify-center p-4 bg-gray-100">
    <div className="text-center space-y-6 max-w-lg">
      <h1 className="text-9xl font-bold text-gray-800">👨‍💻</h1>

      <div className="space-y-2">
        <h2 className="text-3xl font-semibold text-gray-700">Coming Soon</h2>
        <p className="text-gray-600">
          We are working hard to bring you something amazing. This feature will
          be available soon!
        </p>
      </div>
    </div>
  </div>
);

export default ComingSoon;
